module.exports = __webpack_public_path__ + "img/main_hmm.21b02c27.jpg";